module.exports = __webpack_public_path__ + "static/img/bg51.a8311ddb.png";